import React, { createContext, useCallback, useContext, useMemo, useState } from 'react';
import { useDispatch } from 'react-redux';

import makeRequest from '../../apps/main/utils/makeRequest';
import * as Route from '../../apps/main/utils/serverRoutes';

const LocalizationContext = createContext({
  locales: {},
  loading: false,
  availableLanguages: [],
  changeLanguage: () => {},
  fetchAvailableLanguages: () => {},
});

export const LocalizationProvider = ({ children, initialLocales = {} }) => {
  const dispatch = useDispatch();
  const [locales, setLocales] = useState(initialLocales || {});
  const [loading, setLoading] = useState(false);
  const [availableLanguages, setAvailableLanguages] = useState([]);

  const changeLanguage = useCallback(
    (lang) => {
      if (!lang) return;

      setLoading(true);
      makeRequest({
        dispatch,
        url: Route.locales(lang),
        success: (response) => {
          setLocales(response.data);
        },
        finish: () => {
          setLoading(false);
        },
      });
    },
    [dispatch],
  );

  const fetchAvailableLanguages = useCallback(() => {
    makeRequest({
      dispatch,
      url: Route.availableLanguages(),
      success: (response) => {
        setAvailableLanguages(response.data);
      },
    });
  }, [dispatch]);

  const value = useMemo(
    () => ({
      locales,
      loading,
      availableLanguages,
      changeLanguage,
      fetchAvailableLanguages,
    }),
    [locales, loading, availableLanguages, changeLanguage, fetchAvailableLanguages],
  );

  return (
    <LocalizationContext.Provider value={value}>
      {children}
    </LocalizationContext.Provider>
  );
};

export const useLocalization = () => useContext(LocalizationContext);

export { LanguageSelector } from './LanguageSelector';
